import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import LoadingScreen from "../components/LoadingScreen";
import MSKBanner from "../assets/images/MSKBanner.png";
import Fitness from "../assets/images/Fitness.png";
import MentalWellbeing from "../assets/images/MentalWellbeing.png";
import BreatheLab from "../assets/images/BreatheLab.png";

const Dashboard = () => {
  const { getToken } = useAuth();
  const [loading, setLoading] = useState(true);
  const [muscleUrl, setMuscleUrl] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    (async () => {
      try {
        const token = await getToken();
        const resp = await fetch(sdkWrapperURL("/msk/get_url"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: token },
          body: JSON.stringify({}),
          signal: controller.signal,
        });
        const respJSON = await resp.json();
        if (respJSON?.statusCode?.toString().startsWith("2"))
          setMuscleUrl(respJSON.data);
        else throw new Error(respJSON?.message ?? "Error in Fetching MSK URL");
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      controller.abort();
      setLoading(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <LoadingScreen style={{ minHeight: "60vh" }} />
  ) : (
    <section className="p-6 pt-2">
      <Link
        className={`block overflow-hidden rounded-2xl border-2${
          muscleUrl?.length > 0 ? "" : " grayscale pointer-events-none"
        }`}
        to={`/digital-clinic?${new URLSearchParams({
          url: muscleUrl,
        }).toString()}`}
      >
        <span className="sr-only">Digital Clinic for Joint & Muscle Care</span>
        <img
          className="w-full"
          src={MSKBanner}
          alt="Digital Clinic for Joint & Muscle Care"
        />
      </Link>
      <h3 className="mt-8 font-semibold">Daily well-being</h3>
      <div className="mt-4 -mx-6 px-6 space-x-4 flex overflow-x-auto no-scrollbar">
        <Link
          to="/fitness-package"
          className="shrink-0 basis-[60dvw] max-h-48 overflow-hidden rounded-2xl"
        >
          <span className="sr-only">Fitness</span>
          <img className="w-full" src={Fitness} alt="Fitness" />
        </Link>
        <Link
          to="/mental-wellbeing"
          className="shrink-0 basis-[60dvw] max-h-48 overflow-hidden rounded-2xl"
        >
          <span className="sr-only">Mental Wellbeing</span>
          <img
            className="w-full"
            src={MentalWellbeing}
            alt="Mental Wellbeing"
          />
        </Link>
      </div>
      <Link
        to="/content-tabs"
        state={{ name: "Breathe Lab", listID: 18 }}
        className="block mt-8 overflow-hidden rounded-2xl"
      >
        <span className="sr-only">Breathe Lab</span>
        <img className="w-full" src={BreatheLab} alt="Breathe Lab" />
      </Link>
    </section>
  );
};

export default Dashboard;
